import { render, staticRenderFns } from "./DataSourceReport.vue?vue&type=template&id=2677cc78&scoped=true"
import script from "./DataSourceReport.vue?vue&type=script&lang=js"
export * from "./DataSourceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2677cc78",
  null
  
)

export default component.exports